import { render, staticRenderFns } from "./begambleaware.vue?vue&type=template&id=52046811"
import script from "./begambleaware.vue?vue&type=script&lang=js"
export * from "./begambleaware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports